import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import { usePrivacyBanner } from './usePrivacyBanner';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { StyledUILink } from './TextInput.styles';
import { getLegalLink } from '../legal/getLegalLink';
import HubletLocation from './HubletLocation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPrivacyBanner = styled.div.withConfig({
  displayName: "CreateAccountTermsOfService__StyledPrivacyBanner",
  componentId: "sc-1s4kqll-0"
})(["margin-top:20px;text-align:center;", " ", ""], props => props.$shouldShowToSOptionalStep && !props.$hideBorder && ` {
    border-top: 1px solid ${BATTLESHIP};
    padding-top: 20px;
    margin-top: 20px;
  }`, props => props.$isOnLandingPage && `{
    margin-top: 0;
  }`);
const CreateAccountTermsOfService = ({
  hideBorder = false
}) => {
  const {
    createAccountTextI18nLabel,
    handleClickTermsOfService,
    shouldShowToSOptionalStep,
    handleClickDeveloperTermsOfService,
    handleConnectTermsOfUseClick,
    handleClickPrivacyPolicy,
    isOnLandingPage
  } = usePrivacyBanner();
  return /*#__PURE__*/_jsxs(StyledPrivacyBanner, {
    $hideBorder: hideBorder,
    $isOnLandingPage: isOnLandingPage,
    $shouldShowToSOptionalStep: shouldShowToSOptionalStep,
    children: [/*#__PURE__*/_jsx(HubletLocation, {}), /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: createAccountTextI18nLabel,
        options: {
          termsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: getLegalLink('terms-of-service'),
            onClick: handleClickTermsOfService,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "legal.termsOfServiceLink"
            })
          }, "gdprPolicy"),
          developerTermsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: 'https://legal.hubspot.com/developer-terms',
            onClick: handleClickDeveloperTermsOfService,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "legal.developerTermsOfServiceLink"
            })
          }, "gdprPolicyDevelopers"),
          developerCustomerTermsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: getLegalLink('terms-of-service'),
            onClick: handleClickTermsOfService,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "legal.developerCustomerTermsOfServiceLink"
            })
          }, "gdprPolicyCustomers"),
          connectTermsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: getLegalLink('website-terms-of-use'),
            onClick: handleConnectTermsOfUseClick,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "legal.connectTermsOfServiceLink"
            })
          }, "gdprPolicy"),
          hubspotPrivacyPolicyLink: /*#__PURE__*/_jsx(StyledUILink, {
            external: true,
            href: getLegalLink('privacy-policy'),
            onClick: handleClickPrivacyPolicy,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "legal.hubspotPrivacyPolicyLink"
            })
          }, "gdprPolicy")
        }
      })
    })]
  });
};
export default CreateAccountTermsOfService;